import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import EmojiPicker from 'emoji-picker-react';
import { ReactComponent as SmileEmoji } from '../../../../assets/images/ChatImages/smile.svg';
import { ReactComponent as FileSharing } from '../../../../assets/images/ChatImages/filesharing.svg';
import { ReactComponent as Hash } from '../../../../assets/images/ChatImages/hash.svg';
import { ReactComponent as Down } from '../../../../assets/images/TicketImages/down.svg';
import { ReactComponent as Down01 } from '../../../../assets/images/TicketImages/down01.svg';
import { ReactComponent as Public } from '../../../../assets/images/TicketImages/share.svg';
import { ReactComponent as Note } from '../../../../assets/images/TicketImages/note.svg';
import SubmitMenu from './SubmitMenu';

function CreateTicketMessageInput(props) {
  const [inputText, setInputText] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [publicNote, setPublicNote] = useState(false);
  const [submitNote, setSubmitNote] = useState(false);

  const {
    sendMessage,
    editedMessage,
    setSelectedState,
    setActiveTicketMerge,
    handleSubmit,
    description,
    setDescription,
    onCancel,
  } = props;
  useEffect(() => {
    if (editedMessage) {
      setInputText(editedMessage.text);
    }
  }, [editedMessage]);

  const handleSendMessage = () => {
    if (inputText.trim() !== '') {
      sendMessage('User', inputText);
      setInputText('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleToggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleEmojiClick = (emojiObject) => {
    setInputText((prevText) => prevText + emojiObject.emoji);
    setShowEmojiPicker(false);
  };

  return (
    // <div className="ChatMessageInput-Main-Container">
    //   <div className="ChatMessageInput-Container">
    //     {/* <input
    //       placeholder="Description of Ticket ..."
    //       type="text"
    //       value={description}
    //       onKeyPress={handleKeyPress}
    //         onChange={(e) => setDescription(e.target.value)}
    //       className="TicketMessageInput"
    //     /> */}
    //   </div>
    //   {/* <div className="EmojiPicker-Top">
    //     {showEmojiPicker && (
    //       <EmojiPicker
    //         onEmojiClick={handleEmojiClick}
    //         disableAutoFocus
    //         native
    //       />
    //     )}
    //   </div> */}
    //   <div className="ChatMessage-Button-Container">
    //     <div className="ChatMessage-Emoji00">
    //       {/* <p onClick={handleToggleEmojiPicker}>
    //         <SmileEmoji />
    //       </p>
    //       <p>
    //         <FileSharing />
    //       </p> */}
    //       {/* <p>
    //         <Hash />
    //       </p> */}
    //     </div>
    //     <div className="TicketButton-Main-Container">
    //       {/* <button type="button" className="TicketInputButton02" onClick={() => setPublicNote(!publicNote)}>
    //         Public Reply
    //         <span>
    //           <Down01 />
    //         </span>
    //       </button>
    //       {publicNote && (
    //         <div className="PublicMenu-Container">
    //           <div className="PublicMenu-Main">
    //             <Public />

    //             <p onClick={() => setSelectedState(2)}>Public Message</p>
    //           </div>
    //           <div className="PublicMenu-Main" onClick={() => setActiveTicketMerge(true)}>
    //             <Note />

    //             <p>Internal Note</p>
    //           </div>
    //         </div>
    //       )} */}
         
    //       {/* {submitNote && <SubmitMenu />} */}
    //     </div>
    //   </div>
    // </div>
    <div
      className="TicketCreate-form-actions"
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 8,
        width: "100%",
        marginTop: 16,
        flexWrap: "wrap",
      }}
    >
      {typeof onCancel === "function" && (
        <button
          type="button"
          className="TicketInputButton02"
          onClick={onCancel}
          disabled={props.loading}
          style={{ float: "none" }}
        >
          Cancel
        </button>
      )}
      <button
        type="button"
        className="TicketInputButton01"
        onClick={handleSubmit}
        disabled={props.loading}
        style={{ float: "none" }}
      >
        {props.loading ? "Loading..." : "Create Ticket"}
      </button>
    </div>
  );
}

export default CreateTicketMessageInput;
